import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Parameters } from '../../../../../core/entities/parameters.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsParametersComponent } from './dialogs-parameters/edit-dialogs-parameters/edit-dialogs-parameters.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.scss']
})
export class ParametersComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  parametro: Parameters = new Parameters();

  mensajeError: boolean = false;

  constructor(public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router) {
    super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllParameters();
    this.internalHomeService.mostrarMenu();
  }

  pageChange(newPage: number) {
		this.router.navigate([''], { queryParams: { page: newPage } });
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla parametros
  */
  private getAllParameters(): void {
    this.loading = true;
    this.internalHomeService.allParametros().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un parametro
  * @param parametro Opcional. Parametro vacio.
  */
  public createParameter(parametro?: Parameters) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = false;
    parametro = this.parametro;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsParametersComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { parametro, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllParameters();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un parametro
  * @param parametro Opcional. Parametro a editar.
  */
  public editParameter(parametro?: Parameters) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsParametersComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { parametro, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllParameters();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un parametro
  * @param parametro Parametro a eliminar
  */
  public removeParameter(parametro?: Parameters) {
    Utils.toggleAllButtonsAndHref(null);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_param') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(null);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeParametros(parametro).subscribe(res => {
          console.log(res);
          this.getAllParameters();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
